module.exports = __webpack_public_path__ + "img/add_scenario_jaune.50cfc17d.svg";